var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2 7a5.8 5.8 0 1110.081 3.913 4.222 4.222 0 00-2.257-3.009 2.712 2.712 0 00.853-1.975c0-1.512-1.24-2.729-2.743-2.729-1.502 0-2.743 1.217-2.743 2.729 0 .768.32 1.46.832 1.955a4.493 4.493 0 00-2.464 3.072A5.78 5.78 0 011.2 7zm8.95 4.87v-.196a3.016 3.016 0 00-3.016-3.016 3.284 3.284 0 00-3.283 3.213A5.773 5.773 0 007 12.8a5.773 5.773 0 003.15-.93zM0 7a7 7 0 1114 0A7 7 0 010 7zm8.677-1.071a1.54 1.54 0 01-1.543 1.53 1.54 1.54 0 01-1.543-1.53c0-.84.693-1.529 1.543-1.529s1.543.69 1.543 1.529z",
    fill: "#7D8085"
  })));
}
export default __webpack_public_path__ + "static/account.95ba93c7.svg";
export { SvgAccount as ReactComponent };